import React, {useState} from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import {FormSubmit} from 'components/Forms';
import {COOKIE_CONSENT_TYPES} from 'configs/types';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  CustomInput,
} from 'reactstrap';
import {useLocale} from 'contexts/LocaleContext';
import MuiIcon from 'components/Icons/MuiIcon';

// const cookieImg = urljoin(CDN_IMAGE_URL, 'img_cookie_icon.svg');

const consents = [
  {
    title: 'Necessary',
    name: COOKIE_CONSENT_TYPES.necessary,
    description:
      'Necessary cookies keep our site running smoothly by supporting key functions like navigation. The website cannot function without these cookies.',
    necessary: true,
    tooltip: 'Always active',
  },
  {
    title: 'Statistics',
    name: COOKIE_CONSENT_TYPES.analytics,
    description:
      'These cookies help us to understand how visitors interact with the website by collecting and reporting information anonymously, allowing us to improve your experience on our website.',
  },
  {
    title: 'Marketing',
    name: COOKIE_CONSENT_TYPES.marketing,
    description:
      'We use marketing cookies to personalize content and ads, enable social media features, and analyze website traffic. Marketing cookies help us deliver relevant ads and track how well they perform',
  },
];

function CookieConsentContent(props) {
  const {title, name, description, disabled, tooltip, defaultChecked} = props;

  const containerId = `toggle-${name}`;
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };

  return (
    <div className="mb-4">
      <div className="d-flex">
        <h5 className="flex-grow-1">{title}</h5>

        <div id={containerId}>
          <CustomInput
            id={name}
            type="switch"
            size="sm"
            disabled={disabled}
            checked={checked}
            onChange={handleChange}
          />
          <input type="hidden" name={name} value={checked ? '1' : '0'} />
        </div>

        {tooltip && (
          <UncontrolledTooltip target={name} placement="top">
            {tooltip}
          </UncontrolledTooltip>
        )}
      </div>
      <div className="text-muted">{description}</div>
    </div>
  );
}

function CookieConsentModal(props) {
  const {isOpen, toggleOpen, onAcceptCookies} = props;

  const {locale} = useLocale();
  const {in_eu} = locale;

  function handleSubmit(formData) {
    Object.keys(formData).forEach((key) => {
      formData[key] = formData[key] === '1';
    });

    onAcceptCookies({
      necessary: formData.necessary,
      analytics: formData.analytics,
      marketing: formData.marketing,
    });
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleOpen} zIndex={1061} centered>
      <ModalHeader toggle={toggleOpen}>
        <MuiIcon name="cookie" className="mr-2 text-primary" />
        <span className="align-middle">Cookie Preferences</span>
      </ModalHeader>

      <FormSubmit onSubmit={handleSubmit} isSubmitting={false}>
        <ModalBody>
          <p className="mb-4">
            This site uses cookies. We mainly use cookies to improve your
            experience on our website. You can choose which types of cookies you
            want to allow and change your preferences at any time. Disabling
            cookies may affect your experience on this website.
          </p>

          {consents.map((consent, index) => {
            const {necessary, ...rest} = consent;

            // As per GDPR, the default checked option is disabled for EU users
            const defaultChecked = !!necessary || !in_eu;

            return (
              <CookieConsentContent
                key={index}
                disabled={!!necessary}
                defaultChecked={defaultChecked}
                {...rest}
              />
            );
          })}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" outline type="submit">
            Accept cookie selection
          </Button>
          <Button
            type="button"
            color="primary"
            onClick={() => {
              onAcceptCookies({
                necessary: true,
                analytics: true,
                marketing: true,
              });
            }}
          >
            Accept all cookies
          </Button>
        </ModalFooter>
      </FormSubmit>
    </Modal>
  );
}

export default CookieConsentModal;
